<!-- 资讯 -->
<template>
  <div class="home_component ConsultRecommend fd_column">
    <div class="component_title m-b-30">
      <div class="title_mid">
        <div class="title">阅读我们的资讯，更加了解河马艺术</div>
        <div class="subtitle">Reading Information</div>
        <div class="viewMore_more" @click="linkJump(2,'/NewsList')">查看更多</div>
      </div>
    </div>
    <div class="component_box longhair">
      <div
        class="consult"
        v-for="item in listData"
        :key="item.id"
        @click="scrollRecord('Home','Home');linkJump(1,'/NewsDetail', { id: item.id })"
      >
        <div class="consult_img">
          <img :src="imgApi + item.imgUrl" alt="" />
        </div>
        <div class="consult_newsName">
          <div>{{ item.publishDate }}</div>
          <div>{{ item.newsName }}</div>
        </div>
      </div>
    </div>
    <div class="view_more" @click="linkJump(1,'/NewsList')">
      <div>查看更多</div>
      <img src="@/assets/common/view_more.png" alt="" />
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { getList } from "@/api/Home/consult";
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      imgApi: process.env.VUE_APP_BASE_IMAGE,
      listData: [],
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async getList() {
      const res = await getList();
      if (res.code === 1) {
        this.listData = res.data;
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
@import "~@/static/styles/variables.less";
@import "~@/static/styles/index.less";

.ConsultRecommend {
  display: flex;
  flex-direction: column;
  padding-bottom: 0.7292rem;
  .component_box {
    position: relative;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.1563rem;
    row-gap: 0.1563rem;
  }
  .consult {
    width: 2.3958rem;
    border-radius: 10px;
    .consult_img {
      width: 2.3958rem;
      height: 1.9323rem;
      margin-bottom: 0.1563rem;
      overflow: hidden;
      border-radius: 10px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 10px;
        transition: transform 0.3s;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
    .consult_newsName {
      :first-child {
        font-family: Source-Regular;
        font-weight: 400;
        font-size: 0.0938rem;
        color: #999999;
        line-height: 0.1094rem;
        margin-bottom: 0;
      }
      :last-child {
        font-family: Source-Regular;
        font-weight: 500;
        font-size: 0.125rem;
        color: #333333;
        line-height: 0.1458rem;
        margin: 10px 0;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
    }
  }
}
.project_item {
  position: relative;
  overflow: hidden;
  border-radius: 6px 6px 6px 6px;
  width: 700px;
  height: 416px;
  box-sizing: border-box;
  .normal_flex;
  .fd_column;
  justify-content: space-between;

  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #323233;
  line-height: 27px;
  img {
    width: 100%;
    height: 100%;
  }
  .title {
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 70px;
    padding: 0 30px;
    background: rgba(0, 0, 0, 0.43);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    line-height: 27px;
  }
}
@media screen and (max-width: 1024px) {
  .ConsultRecommend .component_box {
    flex-direction: column;
  }
  .ConsultRecommend .consult {
    width: 9.2rem;
  }
  .ConsultRecommend .consult .consult_img {
    width: 9.2rem;
    height: 7.4133rem;
    margin-bottom: 0.4rem;
  }
  .ConsultRecommend .consult .consult_newsName {
    :first-child {
      font-size: 0.32rem;
      line-height: 0.3733rem;
    }
    :last-child {
      font-size: 0.4rem;
      line-height: 0.48rem;
    }
  }
  .view_more {
    display: none;
  }
  .consult_img {
    img {
      &:hover {
        transform: scale(1) !important;
      }
    }
  }
}
</style>
<style lang="less"></style>
